import apiClient from "./axios"

export const getLcDocuments = async (params = {}) => {
  const { data } = await apiClient.get("/lc-documents", { params })
  return data
}

export const getLcDocument = async id => {
  const { data } = await apiClient.get(`/lc-documents/${id}`)
  return data
}

export const createLcDocument = async payload => {
  const { data } = await apiClient.post("/lc-documents", payload)
  return data
}

export const updateLcDocument = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/lc-documents/${id}`, payload)
  return data
}

export const deleteLcDocument = async id => {
  const { data } = await apiClient.delete(`/lc-documents/${id}`)
  return data
}
